import React from "react";
import { formatINR } from "./ChefCard";

export default function CommissionCard({ pricing, title = "Fee summary" }) {
  if (!pricing) return null;
  const rows = [
    ["Monthly salary (billed by Chef Hire)", `₹${formatINR(pricing.monthly_salary)}`],
    ["Engagement", `${pricing.duration_months} month${pricing.duration_months > 1 ? "s" : ""}`],
    ["Placement fee — one month's salary", `₹${formatINR(pricing.commission_amount)}`],
    [`GST (${pricing.gst_pct}%) on fee`, `₹${formatINR(pricing.gst_amount)}`],
  ];
  return (
    <div className="bg-[#1A1A1A] border border-white/10 p-7" data-testid="commission-card">
      <div className="flex items-center justify-between">
        <div className="small-caps text-[10px] text-neutral-400">{title}</div>
        <div className="font-script text-lg text-[#F5B041]">Transparent</div>
      </div>
      <div className="dotted-sep my-5" />
      <div className="space-y-3">
        {rows.map(([k, v]) => (
          <div key={k} className="flex items-center justify-between text-sm gap-4">
            <span className="text-neutral-400">{k}</span>
            <span className="font-serif-menu text-white whitespace-nowrap">{v}</span>
          </div>
        ))}
      </div>
      <div className="dotted-sep my-5" />
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="small-caps text-[10px] text-neutral-500">Payable now (fee + GST)</div>
          <div className="font-serif-display text-3xl text-[#F5B041]" data-testid="commission-total">
            ₹{formatINR(pricing.chefhire_total)}
          </div>
        </div>
        <div className="text-right">
          <div className="small-caps text-[10px] text-neutral-500">Total outlay for engagement</div>
          <div className="font-serif-display text-2xl">₹{formatINR(pricing.grand_total)}</div>
        </div>
      </div>
      <p className="text-[10px] text-neutral-500 mt-5 leading-relaxed">
        Chef Hire charges a one-time placement fee equal to one month's salary, plus GST.
        The staff member is on Chef Hire's payroll and reports to us — the monthly salary is billed through Chef Hire.
      </p>
    </div>
  );
}
